import type { AssetsAssetSchemaTypedWithId } from '@iconik-io/iconik-api/src/services/assets';
import {
  downloadCommentsCsv,
  downloadCommentsSrt,
  downloadCommentsText,
  downloadCommentsVtt,
} from '@iconik-io/shared-lib/src/redux/comments/thunks';

import ContextMenu from '../../components/context_menu/context_menu';
import contextMenuConnector from '../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../components/context_menu/types';
import {
  CONTEXT_MENU_GEARBOX_ASSET_COMMENTS,
  connectContextMenuConsumer,
} from '../../contexts/context_menu';
import { selectAssetCommentIds } from '../../ducks/asset_comments/selectors';
import { selectCurrentVersionId } from '../../ducks/version/selectors';
import { getCurrentRouteParams } from '../../router/current_route_params';
import type { AppDispatch } from '../../store/types';

const getDefinition: GetDefinition<AssetsAssetSchemaTypedWithId> = (
  props,
  state,
) => {
  const [contextItem] = props.contextItems;
  const items: ContextMenuItemDefinition[] = [];
  const routeVersionId = getCurrentRouteParams().versionId;
  const versionId = selectCurrentVersionId(
    state,
    contextItem.id,
    routeVersionId,
  );
  const assetCommentFlatIds = selectAssetCommentIds(
    state,
    contextItem.id,
    versionId,
  );

  items.push({
    label: 'Download as Text',
    action: () => (dispatch: AppDispatch) =>
      dispatch(downloadCommentsText(contextItem.id, versionId)),
    disabled: !assetCommentFlatIds.length,
  });

  items.push({
    label: 'Download as WebVTT',
    action: () => (dispatch: AppDispatch) =>
      dispatch(downloadCommentsVtt(contextItem.id, versionId)),
    disabled: !assetCommentFlatIds.length,
  });

  items.push({
    label: 'Download as SRT',
    action: () => (dispatch: AppDispatch) =>
      dispatch(downloadCommentsSrt(contextItem.id, versionId)),
    disabled: !assetCommentFlatIds.length,
  });

  items.push({
    label: 'Download as CSV',
    action: () => (dispatch: AppDispatch) => {
      dispatch(downloadCommentsCsv(contextItem.id, versionId));
    },
    disabled: !assetCommentFlatIds.length,
  });

  return {
    items,
  };
};

const AssetCommentsGearboxContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_MENU_GEARBOX_ASSET_COMMENTS,
);

export default AssetCommentsGearboxContextMenu;
